import { endpoints } from "@app/api/apis";
import { CreditApplicationType } from "@app/configs/constants";
import AsyncStorage from "@react-native-async-storage/async-storage";
import Button from "@app/sharedComponents/Button/Button";
import { ThemedText, ThemedView } from "@app/theme";
import axios from "axios";
import { useState } from "react";
import { ScrollView, Image, TouchableOpacity } from "react-native"
import { useSelector } from "react-redux";
import { getNextRoute } from "@app/navigationApp/navigationUtil";
import { RootState } from "@app/store/newstore";
import handleApiErr from "@app/helper/handleApiErr";
import { showErrorSheet } from "@app/store/slices/errorSlice";
import { useAppDispatch } from "@app/store/hooks";
const FRAME_ICON = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Frame.svg"
const ICON1 = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/rupee_stack.png"
const PreFetchView = ({
    route,
    navigation
}: {
    route: any;
    navigation: any;
}) => {
    const [btnLoading, setBtnLoading] = useState(false);
    const {userDetails} = useSelector((state: RootState) => state.auth);
    const creditId = userDetails?.linkedCredits[0]?.creditId;
    const dispatch = useAppDispatch();

    const activeEnhancementApplication = userDetails?.activeEnhancementApplication;
    const isEnhancementApplicationInProgress =activeEnhancementApplication && Object.keys(activeEnhancementApplication)?.length > 0;

    const handleIncreaseLimit = async () => {
        setBtnLoading(true);
        let applicationId = await AsyncStorage.getItem('application_id');
        if(applicationId === null || applicationId === undefined) {
            await axios.post(`${endpoints.creditModification}${creditId}/v2`, {
                creditApplicationType: CreditApplicationType.CREDIT_MODIFICATION_AGAINST_SECURITIES,
            }).then((res) => {
                applicationId = res?.data?.applicationId;
                if(applicationId) {
                    AsyncStorage.setItem('application_id', applicationId);
                }
            }).catch((err) => {
                if (err?.data?.statusCode && handleApiErr(err)) {
                    setBtnLoading(false);
                    dispatch(showErrorSheet({
                        isErrorSheetVisible: true,
                        errorMessage: err?.data?.message,
                        closeOnBackdropPress: true,
                        errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
                        errorHeading: err?.data?.header,
                        showErrorHeading: true,
                        btnName: 'Ok, got it!',
                    }))
                    return;
                }
            }).finally(() => {
                setBtnLoading(false);
            })
        }
        const updatedApplicationResponse = await axios.get(`${endpoints.borrowerApplication}${applicationId}`);
        const currentStepId = updatedApplicationResponse.data.currentStepId;
        const route = getNextRoute(
            currentStepId, 
            updatedApplicationResponse.data.applicationState, 
            updatedApplicationResponse.data.stepStatusMap
        );
        navigation.navigate(route);
        setBtnLoading(false);
    }

    return (
        <ThemedView style={{ padding: 16, marginBottom: 16 }} backgroundColor="bg-fill-primary" borderBottomWidth={1} borderColor={'border-secondary'}>
            <ThemedView flex={1} flexDirection="row" alignItems="center" style={{ marginBottom: 16 }}>
                <Image
                    source={{
                        uri: ICON1
                    }}
                    style={{
                        height: 83,
                        width: 56,
                    }}
                />
                <ThemedView flex={1} flexDirection="column" style={{ marginLeft: 16 }}>
                    <ThemedText
                        variant="h3s"
                        color="text-primary"
                    >
                        Increase credit limit
                    </ThemedText>
                    <ThemedText
                        variant="b4r"
                        color="text-secondary"
                    >
                        Unlock additional limit instantly
                    </ThemedText>
                </ThemedView>
            </ThemedView>
            <Button
                eventName={isEnhancementApplicationInProgress ? 'CHECK_LIMIT_BUTTON' : route.name + '_GET_MY_PORTFOLIO'}
                label={isEnhancementApplicationInProgress ? 'Check new limit in 15s' : 'Check eligibility in 15s'}
                handlePress={() => {
                    !btnLoading && handleIncreaseLimit();
                }}
                showRightAccessory={true}
                additionalProperties={{
                    journey : isEnhancementApplicationInProgress ? 'increase_limit' : ''
                }}
                rightAccessory={
                    () => (
                        <Image
                            source={{
                                uri: FRAME_ICON
                            }}
                            style={{
                                height: 24,
                                width: 24,
                            }}
                            resizeMode={'contain'}
                        />
                    )
                }
                type={'SOLID'}
                size='MD'
                bg='bg-primary'
                textColor='text-primary'
                disabled={false}
                buttonLoader={btnLoading}
            />
        </ThemedView>
    )
}

export default PreFetchView;